import { StoreMinusOutlineIcon } from './StoreMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id A5A36489-1F54-4A27-AF99-A0D77723FD1F
 * name store-minus-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-minus-outline.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const ShopMinusOutlineIcon = StoreMinusOutlineIcon;
export default ShopMinusOutlineIcon